// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { needSupportStyles } from "@west/App/Widgets/Header/NeedSupport";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

needSupportStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-end;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};
needSupportStyles.iconStyles = {
    css: css`
        margin-right: 8px;
    `,
};
needSupportStyles.textStyles = {
    size: 14,
    lineHeight: "16px",
    weight: "bold",
};
needSupportStyles.phoneLink = {
    typographyProps: {
        size: 14,
        lineHeight: "16px",
        weight: "bold",
        color: "secondary",
    },
    css: css`
        margin-left: 12px;
        ${xScreen("lte", "sm")} {
            margin-top: 4px;
        }
    `,
};
needSupportStyles.textWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};
